import { render, staticRenderFns } from "./new_status_label.vue?vue&type=template&id=b5ff33b2&scoped=true&"
import script from "./new_status_label.vue?vue&type=script&lang=js&"
export * from "./new_status_label.vue?vue&type=script&lang=js&"
import style0 from "./new_status_label.vue?vue&type=style&index=0&id=b5ff33b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ff33b2",
  null
  
)

export default component.exports